import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiSolidShow, BiSolidHide } from "react-icons/bi";
import { Container, Row, Col } from "react-bootstrap";
import "./Login.css"; // Ensure you have the CSS file
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setRolePermissions } from "../Redux/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  setId,
  setStaffid,
  setStaffname,
  setEmail,
  setDesignation,
} from "../Redux/actions";

const Login = () => {
  const [staffId, setstaffId] = useState();
  const [password, setPassword] = useState();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const gotoPassword = () => {
    navigate("/password");
  };
  const handleShow = () => {
    setShow(!show);
  };

  const [staffIdError, setstaffIdError] = useState("");

  const Id = useSelector((state) => state.staffid);

  useEffect(() => {
    if (Id != "") {
      navigate("/dashboard"); // If logged out, stay on the login page
    }
  }, [Id, navigate]);

  

  const [passwordError, setpasswordError] = useState("");
  const validatePassword = () => {
    if (!password) {
      setpasswordError("Password is required");
      return false;
    }
    if (password.length < 6) {
      setpasswordError("Password must be at least 6 characters long.");
      return false;
    }
    setpasswordError("");
    return true;
  };

const handleLogin = (e) => {
  e.preventDefault();
  
  const isPasswordValid = validatePassword();
  if (!isPasswordValid) return;

  axios
    .post(apiUrl + "login", {
      staffId: staffId,
      password: password,
    })
    .then((res) => {
      if (res.data.message === "Login Successful") {
        toast.success(res.data.message || "Login Successful! 🎉");

        dispatch(setId(res.data._id));
        dispatch(setStaffid(res.data.staffId));
        dispatch(setStaffname(res.data.staffName));
        dispatch(setEmail(res.data.email));
        dispatch(setDesignation(res.data.designation));
        dispatch(setRolePermissions(res.data.roleName, res.data.permissions)); // ✅ updated

        setTimeout(() => navigate("/dashboard"), 3000);
      } else {
        toast.error("Login failed. Please check your credentials ❌");
      }
    })
    .catch((error) => {
      console.error(error);
      toast.error("Login failed. Please check your credentials ❌");
    });
};


  return (
    <div className="container-fluid login">
      <div className="login-col">
        <h1 className="login-txt">Log In</h1>

        <form onSubmit={handleLogin} className="login-form">
          <label>
            <b>Staff ID</b>
          </label>
          <input
            value={staffId}
            type="text"
            name="staffId"
             
            onChange={(e) => setstaffId(e.target.value)}
            placeholder="Enter Your Staff ID"
          />
          

          <label>
            <b>Password</b>
          </label>
          <input
            type={show ? "text" : "password"}
            name="password"
            onBlur={validatePassword}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter Your Password"
          />
          <label onClick={handleShow} className="show-hide">
            {show ? <BiSolidHide /> : <BiSolidShow />}
          </label>
          {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}

          <button onClick={gotoPassword} className="f-password" type="button">
            Forgot Password?
          </button>

          <button type="submit" className="log-btn">
            Log In
          </button>
          <br></br>
          <ToastContainer />
        </form>
      </div>
    </div>
  );
};

export default Login;
